import { MultiReportUploadPanel } from "@/components/multi_report_upload_panel"

const CSV = { "text/csv": [".csv"] }

interface HyVeeUploadSectionProps {
  integrationId: string
  onUploaded: () => void
}

/** Upload the Hy-Vee billback and SAP exports from the supplier portal; queues a `sync-hy-vee` job. */
export function HyVeeUploadSection({ integrationId, onUploaded }: HyVeeUploadSectionProps) {
  return (
    <MultiReportUploadPanel
      endpoint="/api/admin/hyvee/upload"
      fields={{ integration_id: integrationId }}
      slots={[
        {
          field: "billbacks_file",
          title: "Billbacks export",
          description: "All Billbacks Done Within a Date Range (.csv).",
          accept: CSV,
          required: true,
        },
        {
          field: "sap_file",
          title: "SAP AP invoice export",
          description: "Accounts Payable Invoice Information - SAP (.csv).",
          accept: CSV,
          required: true,
        },
      ]}
      successMessage={() => ({
        title: "Upload received",
        description: "Your Hy-Vee billbacks will sync in the background.",
      })}
      onUploaded={onUploaded}>
      <div class="rounded-md border border-blue-200 bg-blue-50 p-3 text-sm text-blue-900 space-y-2">
        <p>
          Log in to the Hy-Vee supplier portal and export both reports below. The SAP file adds sales, discount, and
          payment details to the billbacks, so matching rows are enriched rather than duplicated.
        </p>
      </div>
    </MultiReportUploadPanel>
  )
}
